function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { __privateAdd, __privateGet, __privateSet, __privateWrapper } from "./chunk-PXG64RU4.js";

// src/mutationCache.ts
import { notifyManager } from "./notifyManager.js";
import { Mutation } from "./mutation.js";
import { matchMutation, noop } from "./utils.js";
import { Subscribable } from "./subscribable.js";
var _mutations, _scopes, _mutationId;
var MutationCache = /*#__PURE__*/function (_Subscribable) {
  function MutationCache() {
    var _this;
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, MutationCache);
    _this = _callSuper(this, MutationCache);
    _this.config = config;
    __privateAdd(_this, _mutations);
    __privateAdd(_this, _scopes);
    __privateAdd(_this, _mutationId);
    __privateSet(_this, _mutations, /* @__PURE__ */new Set());
    __privateSet(_this, _scopes, /* @__PURE__ */new Map());
    __privateSet(_this, _mutationId, 0);
    return _this;
  }
  _inherits(MutationCache, _Subscribable);
  return _createClass(MutationCache, [{
    key: "build",
    value: function build(client, options, state) {
      var mutation = new Mutation({
        mutationCache: this,
        mutationId: ++__privateWrapper(this, _mutationId)._,
        options: client.defaultMutationOptions(options),
        state: state
      });
      this.add(mutation);
      return mutation;
    }
  }, {
    key: "add",
    value: function add(mutation) {
      __privateGet(this, _mutations).add(mutation);
      var scope = scopeFor(mutation);
      if (typeof scope === "string") {
        var scopedMutations = __privateGet(this, _scopes).get(scope);
        if (scopedMutations) {
          scopedMutations.push(mutation);
        } else {
          __privateGet(this, _scopes).set(scope, [mutation]);
        }
      }
      this.notify({
        type: "added",
        mutation: mutation
      });
    }
  }, {
    key: "remove",
    value: function remove(mutation) {
      if (__privateGet(this, _mutations).delete(mutation)) {
        var scope = scopeFor(mutation);
        if (typeof scope === "string") {
          var scopedMutations = __privateGet(this, _scopes).get(scope);
          if (scopedMutations) {
            if (scopedMutations.length > 1) {
              var index = scopedMutations.indexOf(mutation);
              if (index !== -1) {
                scopedMutations.splice(index, 1);
              }
            } else if (scopedMutations[0] === mutation) {
              __privateGet(this, _scopes).delete(scope);
            }
          }
        }
      }
      this.notify({
        type: "removed",
        mutation: mutation
      });
    }
  }, {
    key: "canRun",
    value: function canRun(mutation) {
      var scope = scopeFor(mutation);
      if (typeof scope === "string") {
        var mutationsWithSameScope = __privateGet(this, _scopes).get(scope);
        var firstPendingMutation = mutationsWithSameScope == null ? void 0 : mutationsWithSameScope.find(function (m) {
          return m.state.status === "pending";
        });
        return !firstPendingMutation || firstPendingMutation === mutation;
      } else {
        return true;
      }
    }
  }, {
    key: "runNext",
    value: function runNext(mutation) {
      var _a;
      var scope = scopeFor(mutation);
      if (typeof scope === "string") {
        var _ref;
        var foundMutation = (_a = __privateGet(this, _scopes).get(scope)) == null ? void 0 : _a.find(function (m) {
          return m !== mutation && m.state.isPaused;
        });
        return (_ref = foundMutation == null ? void 0 : foundMutation.continue()) !== null && _ref !== void 0 ? _ref : Promise.resolve();
      } else {
        return Promise.resolve();
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      var _this2 = this;
      notifyManager.batch(function () {
        __privateGet(_this2, _mutations).forEach(function (mutation) {
          _this2.notify({
            type: "removed",
            mutation: mutation
          });
        });
        __privateGet(_this2, _mutations).clear();
        __privateGet(_this2, _scopes).clear();
      });
    }
  }, {
    key: "getAll",
    value: function getAll() {
      return Array.from(__privateGet(this, _mutations));
    }
  }, {
    key: "find",
    value: function find(filters) {
      var defaultedFilters = _objectSpread({
        exact: true
      }, filters);
      return this.getAll().find(function (mutation) {
        return matchMutation(defaultedFilters, mutation);
      });
    }
  }, {
    key: "findAll",
    value: function findAll() {
      var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this.getAll().filter(function (mutation) {
        return matchMutation(filters, mutation);
      });
    }
  }, {
    key: "notify",
    value: function notify(event) {
      var _this3 = this;
      notifyManager.batch(function () {
        _this3.listeners.forEach(function (listener) {
          listener(event);
        });
      });
    }
  }, {
    key: "resumePausedMutations",
    value: function resumePausedMutations() {
      var pausedMutations = this.getAll().filter(function (x) {
        return x.state.isPaused;
      });
      return notifyManager.batch(function () {
        return Promise.all(pausedMutations.map(function (mutation) {
          return mutation.continue().catch(noop);
        }));
      });
    }
  }]);
}(Subscribable);
_mutations = new WeakMap();
_scopes = new WeakMap();
_mutationId = new WeakMap();
function scopeFor(mutation) {
  var _a;
  return (_a = mutation.options.scope) == null ? void 0 : _a.id;
}
export { MutationCache };